import React, { useEffect } from 'react';
import { View } from 'react-native';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useRoute } from '@react-navigation/native';

import ServiceNoteButton from '../driver/components/ServiceNoteButton';
import { GET_MACHINE_NOTES, MODIFY_MACHINE } from '../../../common/graphql/machine';
import { useUserContext } from '../../../common/utils/context';
import { ROLE_PERMISSIONS } from '../../../common/constants';

import { Dialog } from '../../components';
import { Screen, SecondaryButton } from '../../design/components';
import PageHeading from '../../design/components/PageHeading';
import { DetailContainer } from '../../containers';
import { app as appActions } from '../../actions';
import useThemedStyles from '../../hooks/useThemedStyles';

import { NoteList, NoteCreatorView, NoteDetailView } from '../note';

const MachineNotesRaw = ({
	data: machine,

	closeDialog,
	openDialog,

	refetch,
}) => {
	const styles = useThemedStyles(createStyles);
	const { hasPermission } = useUserContext();

	const onCreateNote = () => {
		closeDialog();
		if (refetch) {
			refetch();
		}
	};

	const onClickAddNote = () => {
		openDialog(() => (
			<NoteCreatorView
				onSubmitSuccess={onCreateNote}
				showImportant={true}
				initialValues={{ machine: machine.id }}
			/>
		));
	};

	const onClickEditNote = (note) => {
		openDialog(() => (
			<NoteDetailView
				data={note}
				showImportant={true}
			/>
		));
	};

	// remove the dialog when unmounting
	useEffect(() => {
		return () => {
			closeDialog();
		};
	}, [closeDialog]);

	return (
		<View style={styles.container}>
			<PageHeading
				title="Machine notes"
				style={styles.heading}
				action={hasPermission(ROLE_PERMISSIONS.ADD_EDIT_NOTES) && (
					<SecondaryButton label="Add note" icon="plus" onPress={onClickAddNote} />
				)}
			/>
			<NoteList
				items={machine.notes}
				refetchList={refetch}
				onClickEditNote={onClickEditNote}
			/>
			<Dialog />
		</View>
	);
};


const mapDispatchToProps = dispatch => ({
	openDialog: component => dispatch(appActions.openDialog(component)),
	closeDialog: () => dispatch(appActions.closeDialog()),
});

const MachineNotes = compose(
	DetailContainer,
	connect(null, mapDispatchToProps),
)(MachineNotesRaw);

const MachineNotesView = () => {
	const route = useRoute();
	const machineId = route.params?.machineId;

	return (
		<Screen headerRight={<ServiceNoteButton />} scroll={false}>
			<MachineNotes
				id={machineId}
				query={GET_MACHINE_NOTES}
				modifyMutation={MODIFY_MACHINE}
			/>
		</Screen>
	);
};

const createStyles = ({ ui: { space } }) => ({
	container: {
		flex: 1,
	},
	heading: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
	},
});

export default MachineNotesView;
